import React from 'react';

import childrenWithProps from '~/utils/childrenWithProps';

import { getUser } from '~/services/auth';

import Nav from './Nav';
import UserInfo from './UserInfo';

import { Container, Content } from './styles';

const DoctorLayout = ({ children }) => (
  <Container>
    <Nav />
    <Content>
      <UserInfo />
      {childrenWithProps(children, { user: getUser() })}
    </Content>
  </Container>
);

export default DoctorLayout;
